import saveLoadSlice from './slice';
import * as Thunks from './thunks';

export const actions = { ...saveLoadSlice.actions, ...Thunks };
export default saveLoadSlice.reducer;
